import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { DateField, Labeled, RichTextField, Show, TextField, useRecordContext } from "react-admin";
import { ContentPageSX } from "../../../styled/custom";
import CustomerMediaShowTitle from "../../../ui/customer-media-show-title";
import ButtonDownloadField from "../../../ui/button-download-field";
import { CustomerMediaPreview } from "../../../ui/customer-media-preview";
import { MediaThumbnailField } from "../../../ui/media-thumbnail";

const DOWNLOAD_BUTTON_SX = {
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 700,
  px: 1.25,
  py: 0,
  height: 31,
  minHeight: 31,
  lineHeight: 1,
  color: "#ffffff",
  background: "linear-gradient(180deg, #1d9bf0 0%, #0284c7 100%)",
  border: "1px solid rgba(2,132,199,0.35)",
  boxShadow: "0 2px 8px rgba(2, 132, 199, 0.25)",
  "& .MuiSvgIcon-root": { fontSize: 18 },
  "&:hover": {
    background: "linear-gradient(180deg, #38b3ff 0%, #0369a1 100%)",
    boxShadow: "0 4px 12px rgba(2, 132, 199, 0.35)",
  },
};

const sectionSx = {
  p: 2,
  borderRadius: "10px",
  border: "1px solid rgba(0,0,0,0.09)",
  backgroundColor: "#fff",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
  height: "100%",
};

const sectionTitleSx = {
  fontSize: "0.95rem",
  fontWeight: 700,
  color: "#2f2f2f",
  mb: 1.2,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
};

export const DownloadWarningBanner = () => (
  <Typography variant="body1" textAlign="center" color="error" sx={{ mb: 1.5, fontWeight: 600 }}>
    Atencao: a pre-visualizacao pode ser limitada. Realize o download para acessar a versao final completa.
  </Typography>
);

const MediaActions = () => {
  const record = useRecordContext();

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <ButtonDownloadField
        source="media"
        text="Download"
        buttonSx={DOWNLOAD_BUTTON_SX}
        disabledTooltip="Esta mídia não esta incluída no seu plano."
        disabled={Boolean(record && record.can_download === false)}
      />
      <CustomerMediaPreview />
    </Box>
  );
};

const CustomerMediaShow = () => (
  <>
    <DownloadWarningBanner />
    <Show title={<CustomerMediaShowTitle />} sx={ContentPageSX}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mx: "auto", width: "100%" }}>
        <Paper sx={sectionSx}>
          <Typography sx={sectionTitleSx}>Resumo</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={2}>
              <Labeled label="Id">
                <TextField source="id" />
              </Labeled>
            </Grid>
            <Grid item xs={12} md={3}>
              <Labeled label="Classe">
                <TextField source="media_class" sortable={false} />
              </Labeled>
            </Grid>
            <Grid item xs={12} md={4}>
              <Labeled label="Categoria">
                <TextField source="category_media_name" sortable={false} />
              </Labeled>
            </Grid>
            <Grid item xs={12} md={3}>
              <Labeled label="Criado em">
                <DateField source="created_at" locales="pt-BR" sortable={false} showTime />
              </Labeled>
            </Grid>
          </Grid>
        </Paper>

        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper sx={sectionSx}>
              <Typography sx={sectionTitleSx}>Conteudo</Typography>
              <TextField source="name" label="Nome" sortable={false} />
              <TextField source="description" label="Descricao" sortable={false} />
              <Labeled label="Corpo" fullWidth>
                <div
                  style={{
                    background: "#fefefe",
                    border: "1px solid rgba(0,0,0,0.15)",
                    padding: "10px",
                    borderRadius: "8px",
                    minHeight: "100px",
                    overflow: "auto",
                  }}
                >
                  <RichTextField source="body" label="Corpo" sortable={false} />
                </div>
              </Labeled>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper sx={sectionSx}>
              <Typography sx={sectionTitleSx}>Thumbnail</Typography>
              <MediaThumbnailField scale={0.55} />
            </Paper>
          </Grid>
        </Grid>

        <Paper sx={sectionSx}>
          <Typography sx={sectionTitleSx}>Arquivo e Acoes</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <Labeled label="Tipo">
                <TextField source="type" sortable={false} />
              </Labeled>
            </Grid>
            <Grid item xs={12} md={9}>
              <Labeled label="Acoes">
                <MediaActions />
              </Labeled>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Show>
  </>
);

export default CustomerMediaShow;
